/**
 * Product gallery — ang3lbyt loader while slide images load (mobile + desktop).
 */
(function () {
  function waitForImage(img) {
    return new Promise(function (resolve) {
      if (!img || (img.complete && img.naturalHeight !== 0)) {
        resolve();
        return;
      }

      img.addEventListener('load', resolve, { once: true });
      img.addEventListener('error', resolve, { once: true });
    });
  }

  function bindImage(img) {
    if (img.dataset.mediaLoaderBound === 'true') return;
    img.dataset.mediaLoaderBound = 'true';

    var container = img.closest('.product-media-container');
    if (!container) return;

    if (!container.classList.contains('is-media-loading')) {
      container.classList.add('is-media-loading');
    }

    function finish() {
      container.classList.remove('is-media-loading');
      img.classList.add('is-media-loaded');
    }

    if (img.complete && img.naturalHeight !== 0) {
      finish();
      return;
    }

    img.addEventListener('load', finish, { once: true });
    img.addEventListener('error', finish, { once: true });
  }

  function getWrapper(root) {
    if (root && root.classList && root.classList.contains('product__media-wrapper')) {
      return root;
    }

    if (root && root.querySelector) {
      var scoped = root.querySelector('.product__media-wrapper');
      if (scoped) return scoped;
    }

    return document.querySelector('product-info.product-info--main .product__media-wrapper');
  }

  function getPrimaryImage(wrapper) {
    return wrapper.querySelector(
      '.product__media-list:not(.product__media-list--additional) .product__media-item:first-child img, .product__media-list:not(.product__media-list--additional) .product__media-item:first-child .deferred-media__poster img'
    );
  }

  async function initProductMediaLoader(root) {
    var wrapper = getWrapper(root);
    if (!wrapper) return;

    var images = wrapper.querySelectorAll('.product__media-item img, .product__media-item .deferred-media__poster img');
    if (!images.length) {
      wrapper.classList.add('is-media-ready');
      return;
    }

    images.forEach(bindImage);

    wrapper.classList.remove('is-media-ready');

    var firstImg = getPrimaryImage(wrapper);

    await Promise.race([
      waitForImage(firstImg),
      new Promise(function (resolve) {
        setTimeout(resolve, 5000);
      }),
    ]);

    wrapper.classList.add('is-media-ready');
  }

  function init() {
    if (!document.body.classList.contains('product-page')) return;
    initProductMediaLoader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initProductMediaLoader(event.target);
  });
})();
